import { aiAssistPromptsEditorStateStore } from '@web-config-app/core';
import React, { createContext, useRef } from 'react';

export const AiAssistPromptsEditorStateStoreContext = createContext<
  typeof aiAssistPromptsEditorStateStore | null
>(null);

export function AiAssistPromptsEditorStateStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const store = useRef(aiAssistPromptsEditorStateStore);

  return (
    <AiAssistPromptsEditorStateStoreContext.Provider value={store.current}>
      {children}
    </AiAssistPromptsEditorStateStoreContext.Provider>
  );
}
